"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@formily/core");
var shared_1 = require("@formily/shared");
var context_1 = __importStar(require("../context"));
exports.useFormSpy = function (props) {
    var broadcast = react_1.useContext(context_1.BroadcastContext);
    var form = react_1.useContext(context_1.default);
    var initializedRef = react_1.useRef(false);
    var unmountRef = react_1.useRef(false);
    var timerRef = react_1.useRef({});
    var subscriberId = react_1.useRef();
    var _a = react_1.useState(core_1.LifeCycleTypes.ON_FORM_INIT), type = _a[0], setType = _a[1];
    var _b = react_1.useReducer(function (state, action) { return props.reducer(state, action, form); }, props.initialState || {}), state = _b[0], dispatch = _b[1];
    var subscriber = react_1.useCallback(function (_a) {
        var type = _a.type, payload = _a.payload;
        var _b;
        if (initializedRef.current)
            return;
        var key = type + "_" + ((_b = payload === null || payload === void 0 ? void 0 : payload.state) === null || _b === void 0 ? void 0 : _b.name);
        clearTimeout(timerRef.current[key]);
        timerRef.current[key] = setTimeout(function () {
            if (unmountRef.current)
                return;
            payload = payload && shared_1.isFn(payload.getState) ? payload.getState() : payload;
            if (shared_1.isStr(props.selector) && shared_1.FormPath.parse(props.selector).match(type)) {
                setType(type);
                dispatch({
                    type: type,
                    payload: payload
                });
            }
            else if (shared_1.isArr(props.selector)) {
                if (!!props.selector.find(function (str) {
                    if (shared_1.isStr(str)) {
                        return str === type;
                    }
                    else if (shared_1.isArr(str)) {
                        if (str.length < 2) {
                            return str[0] === type;
                        }
                        else {
                            return (str[0] === type &&
                                shared_1.FormPath.parse(str[1]).matchAliasGroup(payload.name, payload.path));
                        }
                    }
                })) {
                    setType(type);
                    dispatch({
                        type: type,
                        payload: payload
                    });
                }
            }
        });
    }, []);
    react_1.useMemo(function () {
        initializedRef.current = true;
        if (broadcast) {
            subscriberId.current = broadcast.subscribe(subscriber);
        }
        else if (form) {
            subscriberId.current = form.subscribe(subscriber);
        }
        initializedRef.current = false;
    }, []);
    react_1.useEffect(function () {
        return function () {
            if (form) {
                form.unsubscribe(subscriberId.current);
            }
            else if (broadcast) {
                broadcast.unsubscribe(subscriberId.current);
            }
            unmountRef.current = true;
        };
    }, []);
    var formApi = broadcast ? broadcast && broadcast.getContext() : form;
    return {
        form: formApi,
        type: type,
        state: state
    };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/hooks/useFormSpy.js
// module id = 2075
// module chunks = 0